import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AskResult } from '../components/support-popup/models/AskResult';
import { AskApiService } from './API/help/ask-api.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ResultService {
  constructor(private askApiService: AskApiService, private http: HttpClient) {
  }

  public getAskResult(query: string): Observable<AskResult> {
    return this.askApiService.getResult(query);
  }
}
